import React, { useContext, useRef } from 'react';
import classes from './FindContent.module.scss';
import { useDimensions } from '../../../hooks/useDimensions';
import classNames from 'classnames';
import { TopNavContext } from '../../../providers/TopNavProvider';
import { FluidContentLayout } from '../../../components/containers/FluidContentLayout';
import { UseFormReturn } from 'react-hook-form';
import { TreeMenu } from './TreeMenu';
import { ContentFilter } from './ContentFilter';
import {
  CoreImportFolderFieldsFragment,
  ImportSourceFieldsFragment,
  SocialProfileFieldsFragment
} from '../../../models/graphql';
import { PostCardGrid } from './PostCardGrid';
import { FindContentProvider } from './FindContentProvider';
import { TreeMenuProvider } from './TreeMenu/TreeMenuProvider';
import { BiggerScreenPlaceholder } from '../../../components/containers/BiggerScreenPlaceHolder';
import { useBreakpoints } from '../../../hooks/useBreakpoints';
import { topNavOffsetClassesGetter } from '../../../helpers/topNavOffsetClasses';
import { ScrollProvider } from 'providers/ScrollProvider';

export type FindContentViewProps = {
  sources: ImportSourceFieldsFragment[];
  folders: CoreImportFolderFieldsFragment[];
  useFormInstance: UseFormReturn;
  profiles: SocialProfileFieldsFragment[];
  reFetch: CallableFunction;
  fetchMorePosts: (callBack: CallableFunction) => void;
};

export const FindContentView = (props: FindContentViewProps): JSX.Element => {
  const { useFormInstance, profiles, reFetch, folders, sources, fetchMorePosts } = props;
  const platform = useFormInstance.getValues('platform');
  const platformType = useFormInstance.getValues('type');

  const leftColRef = useRef<HTMLDivElement>(null);
  const rightColRef = useRef<HTMLDivElement>(null);

  const { hasScrollbar: hasLeftScrollbar } = useDimensions(leftColRef);
  const topNavOffsetContext = useContext(TopNavContext);

  const topNavClasses = topNavOffsetClassesGetter(topNavOffsetContext.state.visibility, 0);

  const treeMenuHeaderClasses = classNames(classes.TreeMenuHeader, 'margin-bottom-small-16');
  const leftColumnWrapperClass = classNames(
    classes.LeftSideWrapper,
    'cell',
    'show-for-small',
    topNavClasses.vheight,
    topNavClasses.top
  );
  const leftColumnClass = classNames(classes.LeftSideColumn, hasLeftScrollbar ? classes.LeftSideColumnScroller : null);
  const rightColumnWrapperClass = classNames(topNavClasses.vheight, classes.RightSideColumn);
  const breakpoint = useBreakpoints();

  const { width } = useDimensions(rightColRef);
  if (breakpoint === 'medium' || breakpoint === 'small') {
    return <BiggerScreenPlaceholder />;
  }
  return (
    <FindContentProvider
      fetchMorePosts={fetchMorePosts}
      profiles={profiles}
      platform={platform}
      platformType={platformType}>
      <form>
        <TreeMenuProvider reFetchTreeMenu={reFetch} sources={sources} folders={folders}>
          <FluidContentLayout loading={false}>
            <div className={classes.FindContentWrapper}>
              <div className={leftColumnWrapperClass}>
                <div className={leftColumnClass} ref={leftColRef}>
                  <div className={treeMenuHeaderClasses}>Saved Feeds</div>
                  <TreeMenu />
                </div>
              </div>
              <ScrollProvider className={rightColumnWrapperClass}>
                <div ref={rightColRef}>
                  <ContentFilter useFormInstance={useFormInstance} />
                  {platform && (
                    <PostCardGrid
                      parentWidth={width}
                      profiles={profiles}
                      engageAsHandler={() => {
                        // ...
                      }}
                      formInstance={useFormInstance}
                    />
                  )}
                </div>
              </ScrollProvider>
            </div>
          </FluidContentLayout>
        </TreeMenuProvider>
      </form>
    </FindContentProvider>
  );
};
